import { render, staticRenderFns } from "./CanteenForm.vue?vue&type=template&id=8513d9fc&"
import script from "./CanteenForm.vue?vue&type=script&lang=js&"
export * from "./CanteenForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports